import * as actions from './actions'
import * as mutations from './mutations'

export default {
  namespaced: true,
  state: {
    accessToken: null,
    user: null,
    organization: null,
    softswitchIntegration: null,
    financialData: null,
    impersonation: null,
    onboarding: null
  },
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/index.js